import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['link']
  static values = { url: String }

  connect() {
    this.createAndAttachBlob().then(blob => {
      this.attachBlob(blob)
    })
  }

  createAndAttachBlob() {
    return fetch(this.urlValue)
      .then(response => response.blob())
      .then(blob => blob)
      .catch((error) => {
        // console.error(error)
      })
  }

  attachBlob(blob) {
    if (blob) {
      const url = URL.createObjectURL(blob)
      this.linkTarget.href = url
    } else {
      this.linkTarget.href = null
    }
  }
}
